import { isTouch } from '../_app/cuchillo/core/Basics';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Default from './Default';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import Cursor from '../_app/cuchillo/cursor/Cursor';
import Keyboard from '../_app/cuchillo/core/Keyboard';
import Sketch from '../3D/Sketch';
import gsap from 'gsap';

export default class New extends Default {
  constructor() {
    super();
  }

  beforeShow() {
    Scroll.init(Scroll.AXIS_Y, { domResize: this.container, smooth: !isTouch, multiplicator: 1 });
    Cursor.reset();
    Keyboard.mountPage(this.id);

    if (this.isFirstTime) {
      Sketch.start();
      gsap.set(this._curtain, { opacity: 0 });
    }
  }

}

ControllerPage._addPage('new', New);
